<template>
  <div>
    <v-layout>
      <v-flex xs12 sm12>
        <v-toolbar size="120px" dark color="info">
          <v-toolbar-title> {{ $t('Invoice-Settings') }} </v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container fluid>

      <v-layout row wrap>

        <v-btn @click="efaturagetir(1)" style="width:200px" color="info" dark>{{$t('E-invoice-Settings')}}
        </v-btn>
        <v-btn @click="earsivgetir(2)" style="width:200px" color="info" dark> {{$t('E-archive-Settings')}}
        </v-btn>




      </v-layout>
      <v-dialog v-model="dialog" scrollable="" persistent="" max-width="500px">
        <v-card color="grey lighten-5">
          <v-card-title>{{baslik}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row="" wrap="">
              <div class="flex md12">
                <v-checkbox v-model="prm.Unvan2Pasif" :label="$t('Do-not-send-Current2')"></v-checkbox>
                <v-checkbox v-model="prm.BorusanFaturasi" :label="$t('Borusan-Invoice')"></v-checkbox>
                <v-checkbox v-model="prm.FaturaTarihiDegismesin" :label="$t('invoices-7-days')">
                </v-checkbox>
                <v-checkbox v-model="prm.SabitSeri" :label="$t('Invoice-Serial-Constant')"></v-checkbox>
                <v-checkbox v-model="prm.FaturaGonderilmisUyarisiGonderimiKesmesin"
                  :label="$t('Warning-Invoice-Delivered')"></v-checkbox>
                <v-checkbox v-model="prm.AciklamaToSellersItemIdentification"
                  :label="$t('SellersItemIdentification-Area')"></v-checkbox>
                <v-text-field v-model="prm.EFatSeriSonHarf" :label="$t('Third-character-Invoice-No')" maxlength="1">
                </v-text-field>
                
                <v-checkbox v-model="prm.Adres2Birlestir" :label="$t('Merge-Address-2')"></v-checkbox>
                <v-text-field v-model="prm.BankaIBAN" :label="$t('BANK-IBAN')" maxlength="50"></v-text-field>
                <v-text-field v-model="prm.BankaParaBirimi" :label="$t('Bank-Currency-Type')" maxlength="3"></v-text-field>
                <v-text-field v-model="prm.BankaNot" :label="$t('Bank-Note')" maxlength="150"></v-text-field>

                <v-text-field v-model="prm.BankaOdemeTipi" :label="$t('Bank-Payment-Method')" maxlength="15"></v-text-field>
                <v-text-field v-model="prm.BankaOdemeKanalKodu" :label="$t('Bank-Payment-Channel-Code')" maxlength="15"></v-text-field>
                <v-checkbox v-model="prm.VadeTarihiYaz" :label="$t('Write-Term-Date')"></v-checkbox>
                <v-text-field v-model="prm.TevkifatAciklama" :label="$t('Withholding-Explanation')" maxlength="150"></v-text-field>
                <v-checkbox v-model="prm.TCKN_UnvanYaz" :label="$t('Write-Title-details-invoices-issued-TCID')"></v-checkbox>
                <v-checkbox v-model="prm.TCKN_UnvanAdSoyad" :label="$t('Write-name-surname-Title-details-invoices-issued-TCID')"></v-checkbox>
                <v-checkbox v-model="prm.CoperMalzemeAdiMalzemeKoduDegistir" label="Coper Faturalarında Malzeme Kodu ve Adı yer değiştirsin"></v-checkbox>
                <v-checkbox v-model="prm.HizmetNoBasliktaYazilmasin" label="Hizmet No başlığa yazılmasın"></v-checkbox>
                



              </div>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" v-if="tip==1" flat @click="PrmKaydet(1)">{{ $t('OK') }}</v-btn>
            <v-btn color="blue darken-1" v-if="tip==2" flat @click="PrmKaydet(2)">{{ $t('OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </v-container>
  </div>


</template>



<script>
  import auth from '../../../api/auth'
  import parainput from "@/components/app/customcomp/parainput.vue"
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import tool from "../coper/tools";


  export default {
    data() {
      return {
        tip: 1,
        baslik: null,
        prm: {
          Unvan2Pasif: false,
          BorusanFaturasi: false,
          FaturaTarihiDegismesin: false,
          SabitSeri: false,
          EFatSeriSonHarf: "",
          FaturaGonderilmisUyarisiGonderimiKesmesin: false,
          AciklamaToSellersItemIdentification: false
        },


        kur: null,
        hesaptipi: [{
            text: this.$t('Ticket-Amount'),
            value: 0
          },
          {
            text:  this.$t('Ticket-Amount') +'+'+ this.$t('Taxes'),
            value: 1
          }
        ],


        doviztipi: [],
        dialogservis: false,
        itemsei: ['E', 'I'],
        defaultvalue: 0,
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',
        dialogvergi: false,

        tumparametreler: [],
        dialog: false,
        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },


    methods: {
      efaturagetir(a) {
        this.dialog = true
        this.baslik = this.$t('E-invoice-Settings')   
        this.tip = a
        this.PrmGoster(a)
      },
      earsivgetir(a) {
        this.dialog = true
        this.baslik = this.$t('E-archive-Settings')
        this.tip = a
        this.PrmGoster(a)
      },
      Kaydet: Kaydet,
      firmabilgilerigetir: firmabilgilerigetir,
      vergibilgigetir: vergibilgigetir,
      vergikaydetkapat: vergikaydetkapat,
      servisbilgigetir: servisbilgigetir,
      PrmKaydet,
      PrmGoster
    },
    components: {
      parainput,
      yuzdeinput
    }
  }

  function PrmKaydet(tip) {
    var prm = {
      tip: tip,
      prm: this.prm
    };

    tool.api_post(this, "EFatura/ParametreSave", prm).then(
      response => {
        this.dialog = false;
      },
      response => {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    );

  }

  function PrmGoster(tip) {
    var prm = {
      tip: tip
    };


    tool.api_post(this, "EFatura/ParametreLoad", prm).then(

      response => {
        this.prm = response.body;


      },
      response => {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    );
  }



  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      GenelParametre: this.tumparametreler.GenelParametre,
      RaporParametre: this.tumparametreler.RaporParametre,
      FirmaParametre: this.FirmaParametre,
      SirketKodu: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.dialog = false

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }

  function vergikaydetkapat() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    this.VergiParametre.SirketKod = credentials.SirketKodu;

    var params = this.VergiParametre;

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.dialogvergi = false;
      this.text1 = response.body.ResponseMessage
      this.snackbar = true


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })






  }

  function servisbilgigetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketServiceParametreLoad', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      response.body.forEach(element => {

        if (element.ServisKod == '11') {
          this.ServisParametre.Fiyat11 = element.Fiyat;
          this.ServisParametre.Doviztip11 = element.DovizTip;
          this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '12') {

          this.ServisParametre.Fiyat12 = element.Fiyat;
          this.ServisParametre.Doviztip12 = element.DovizTip;
          this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '13') {

          this.ServisParametre.Fiyat13 = element.Fiyat;
          this.ServisParametre.Doviztip13 = element.DovizTip;
          this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '15') {
          this.ServisParametre.Fiyat15 = element.Fiyat;
          this.ServisParametre.Doviztip15 = element.DovizTip;
          this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '19') {
          this.ServisParametre.Fiyat19 = element.Fiyat;
          this.ServisParametre.Doviztip19 = element.DovizTip;
          this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '21') {
          this.ServisParametre.Fiyat21 = element.Fiyat;
          this.ServisParametre.Doviztip21 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '22') {
          this.ServisParametre.Fiyat22 = element.Fiyat;
          this.ServisParametre.Doviztip22 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '31') {
          this.ServisParametre.Fiyat31 = element.Fiyat;
          this.ServisParametre.Doviztip31 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '32') {
          this.ServisParametre.Fiyat32 = element.Fiyat;
          this.ServisParametre.Doviztip32 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '33') {
          this.ServisParametre.Fiyat33 = element.Fiyat;
          this.ServisParametre.Doviztip33 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '40') {
          this.ServisParametre.Fiyat40 = element.Fiyat;
          this.ServisParametre.Doviztip40 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

        if (element.ServisKod == '44') {
          this.ServisParametre.Fiyat44 = element.Fiyat;
          this.ServisParametre.Doviztip44 = element.DovizTip;
          this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
          this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
          this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
        }

      });



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })



    this.dialogservis = true;
  }


  function vergibilgigetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.VergiParametre = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.dialogvergi = true;
  }


  function firmabilgilerigetir() {

    this.dialog = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.tumparametreler = response.body
      this.FirmaParametre = response.body.FirmaParametre



    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }
</script>